var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-624 -314)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C15.7581 6.5 19.12 8.53 20.8366 11.76C20.9178 11.91 20.9178 12.09 20.8366 12.24C19.12 15.47 15.7581 17.5 12 17.5C8.24192 17.5 4.87996 15.47 3.16343 12.24C3.08218 12.09 3.08218 11.91 3.16343 11.76C4.87996 8.53 8.24192 6.5 12 6.5ZM12 4.5C7.23638 4.5 3.12281 7.24 1.18283 11.2C0.939058 11.7 0.939058 12.3 1.18283 12.8C3.12281 16.76 7.23638 19.5 12 19.5C16.7636 19.5 20.8772 16.76 22.8172 12.8C23.0609 12.3 23.0609 11.7 22.8172 11.2C20.8772 7.24 16.7636 4.5 12 4.5ZM12 9.5C13.6251 9.5 14.8947 11 14.4478 12.67C14.2244 13.51 13.5235 14.2 12.6704 14.42C10.9741 14.85 9.4506 13.6 9.4506 12.01C9.4506 10.63 10.5882 9.51 11.9898 9.51L12 9.5ZM13.229 7.67C9.75531 6.76 6.65743 9.81 7.58172 13.23C7.988 14.73 9.21699 15.95 10.7507 16.35C14.2244 17.26 17.3223 14.21 16.398 10.79C15.9917 9.29 14.7627 8.07 13.229 7.67V7.67Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibility);
export default __webpack_public_path__ + "static/media/icon-visibility.f174d57f7bd37d51a4e93e162c562ddb.svg";
export { ForwardRef as ReactComponent };